import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import md5 from 'js-md5';
// 引入jQuery、bootstrap
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import $ from 'jquery'
import "./utils/filter"
import 'bootstrap'
import './styles/iconfont.css'
// 引入bootstrap样式
import 'bootstrap/dist/css/bootstrap.min.css'

import 'bootstrap/dist/js/bootstrap.min.js'
import OrderPay from './utils/modal'



Vue.prototype.$ = $
Vue.config.productionTip = false
Vue.use(Antd);
Vue.use(ElementUI);

import { Message } from 'element-ui'
//定义一个新的Message方法
let messageInstance = null;
const $message = options => {
    if(messageInstance) {
        //判断是否有提示框，有则关闭
        messageInstance.close();
    }
    messageInstance = Message(options);
    return messageInstance;
};

//重写方法
['success', 'warning', 'info', 'error'].forEach(type => {
    $message[type] = options => {
        if (typeof options === 'string') {
            options = {
                message: options
            };
        }
        options.type = type;
        options.offset = 55;
        options.center = true;
        options.showClose = true;
        return Message(options);
    };
});
//将$message挂载到this上
Vue.prototype.$message = $message;
Vue.prototype.$message.closeAll = Message.closeAll;

Vue.prototype.bus = new Vue()
Vue.prototype.$md5 = md5;
Vue.prototype.$OrderPayBox = OrderPay.install;
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')